export const IconBarCode = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M0 1.88879H0.939698V14.1111H0V1.88879ZM1.51483 14.1111H2.04387V1.88879H1.51483V14.1111ZM2.42519 14.1111H2.95319V1.88879H2.42519V14.1111ZM3.64774 14.1111H4.8043V1.88879H3.64774V14.1111ZM5.73037 14.1111H6.30865V1.88879H5.73037V14.1111ZM7.2054 14.1111H9.60231V1.88879H7.2054V14.1111ZM13.4512 14.1111H14.239V1.88879H13.4512V14.1111ZM14.9262 1.88879V14.1111H16V1.88879H14.9262ZM10.564 14.1111H11.0794V1.88879H10.564V14.1111ZM11.818 14.1111H12.3334V1.88879H11.818V14.1111Z"
                fill="#FF5120"
            />
        </svg>
    );
};
